// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2mG-1","inputDescription":"styles_inputDescription__28SW1"};